export const getMultiDayShiftDayMetadata = (
  multiDayShiftId: string,
  multiDayShiftDayIndexes: Record<string, number>,
  multiDayShiftGroupSizes: Record<string, number>
): { multiDayShiftDayIndex: number; multiDayShiftDayCount: number } => {
  const currentIndex = multiDayShiftDayIndexes[multiDayShiftId] ?? 0;
  multiDayShiftDayIndexes[multiDayShiftId] = currentIndex + 1;

  return {
    multiDayShiftDayIndex: currentIndex,
    multiDayShiftDayCount: multiDayShiftGroupSizes[multiDayShiftId],
  };
};
